import { VCard, VCardActions, VDialog, VSpacer } from 'vuetify/components'
import JButton from '../JButton'
import '../../../../src/assets/stylus/ui/_alert.scss'

export default {
  name: 'j-alert',
  components: {
    JButton,
    VCard,
    VCardActions,
    VDialog,
    VSpacer,
  },
  props: {
    activatorOn: Boolean,
    button: { type: Array, default: () => [true, true, true],},
    buttonText: { type: Array, default: () => ['Yes', 'No', 'Cancel'],},
    maxWidth: {
      type: [String, Number],
      default: '290',
    },
    message: {
      type: String,
      default: 'No informing message.',
    },
    title: String,
    titleDescription: String,
    type: { type: String, default: 'INFO' }, // ['INFO', 'WARN']  },
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'yes', 'no', 'cancel'],

  render() {
    const isWarn = this.type === 'WARN'
    const bgClass = isWarn ? 'pink' : 'sky'

    const contentClass = [ 'v-dialog', 'j_alert', 'type01', isWarn ? 'alert' : 'success' ].join(' ')
    // const _attrs = {
    //   buttons: [
    //     {
    //       class: { type02: true, pink: this.type == 'WARN', sky: this.type == 'INFO' },
    //       onClick: () => { this.$emit('yes') },
    //     },
    //     {
    //       class: { type02: true, pink: this.type == 'WARN', sky: this.type == 'INFO' },
    //       onClick: () => { this.$emit('no') },
    //     },
    //     {
    //       class: { type02: true, white: true },
    //       onClick: () => { this.$emit('cancel') },
    //     },
    //   ],
    //   message: {
    //     domProps: {
    //       innerHTML: this.message,
    //     },
    //   },
    //   vDialog: {
    //     maxWidth: this.maxWidth,
    //     persistent: true,
    //     modelValue: this.modelValue,
    //     'onUpdate:modelValue': (e) => this.$emit('update:modelValue', e),
    //     contentClass: { contentClass }
    //   },
    // }
    return (
      <v-dialog 
        modelValue={this.modelValue}
        onUpdate:modelValue={val => this.$emit('update:modelValue', val)}
        persistent
        maxWidth={this.maxWidth}
        contentClass={contentClass}
        >
      
        <v-card class='v-sheet' style={{ backgroundColor: 'transparent !important' }}>
          <div class="alert__contents">
            <i></i>
            <p>
              <span>{ this.title ?? (isWarn ? 'Alert!' : 'Success!') }</span>
              <small innerHTML={this.message}></small>
            </p>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>

            { this.button[0] && (
              <JButton class={{ type02: true, [bgClass]: true }} onClick={() => this.$emit('yes')}>
                { this.buttonText[0] }
              </JButton>
            )}

            { this.button[1] && (
              <JButton class={{ type02: true, [bgClass]: true }} onClick={() => this.$emit('no')}>
                { this.buttonText[1] }
              </JButton>
            )}

            { this.button[2] && (
              <JButton class={{ type02: true, white: true }} onClick={() => this.$emit('cancel')}>
                { this.buttonText[2] }
              </JButton>
            )}
          </v-card-actions>
        </v-card>
      </v-dialog>
    )
  },
}
